module.exports = __webpack_public_path__ + "static/media/iting.d8511e8a.png";